import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function ChangeRealization({ onSelect, onClose }) {
  const [realizations, setRealizations] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadData = async () => {
    try {
      const response = await axios.get('https://megamont.pl/api/all-realizations');
      setRealizations(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Błąd podczas ładowania realizacji:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg">
          
          <div className="modal-header bg-light">
            <h5 className="modal-title fw-bold gradient-text">Wybierz Realizację</h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
          </div>

          <div className="modal-body p-0" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            <table className="table table-hover m-0">
              <thead className="table-light sticky-top">
                <tr>
                  <th className="ps-4">ID</th>
                  <th>Nazwa Realizacji</th>
                  <th>Data dodania</th>
                  <th className="text-end pe-4">Wybierz</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="4" className="text-center py-5">
                      <div className="spinner-border text-primary" role="status"></div>
                      <div className="mt-2">Ładowanie listy...</div>
                    </td>
                  </tr>
                ) : realizations.length > 0 ? (
                  realizations.map((realization) => (
                    console.log(realization),
                    <tr key={realization.id} style={{ cursor: 'pointer' }} onClick={() => onSelect(realization)}>
                      <td className="ps-4">{realization.id}</td>
                      <td className="fw-bold">{realization.name}</td>
                      <td>{new Date(realization.date).toLocaleDateString()}</td>
                      <td className="text-end pe-4">
                        <button 
                          className="btn btn-sm btn-success px-3" 
                          onClick={(e) => {
                            e.stopPropagation(); // zapobiega podwójnemu kliknięciu
                            onSelect(realization);
                          }}
                        >
                          Wybierz
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center py-5 text-muted">Brak realizacji w bazie danych.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="modal-footer bg-light">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Anuluj</button>
          </div>

        </div>
      </div>
    </div>
  );
}